<div class="checkbox">
    <input type="checkbox" [formControl]="checkBoxControl" [id]="idByGroup"/>
    <label [for]="idByGroup">{{ name }} <span> ({{ count }})</span></label>
</div>
